import { FF_EXPORT_WORKFLOW_LINEAGE, FF_EXPORT_WORKFLOW_LINEAGE_ENTERPRISE } from '@/consts/featureFlags';
import { useUserStore } from '@/state/user.state';
import { SubscriptionType } from '@/types/shared';
import { useFeatureFlag } from './useFeatureFlag';

export function useIsWorkflowLineageEnabled(): boolean {
  const { value: enabled } = useFeatureFlag(FF_EXPORT_WORKFLOW_LINEAGE);
  const { value: enterpriseEnabled } = useFeatureFlag(FF_EXPORT_WORKFLOW_LINEAGE_ENTERPRISE);
  const subscriptionType = useUserStore((state) => state.user?.activeWorkspace?.subscription?.type);
  return !!enabled || (subscriptionType === SubscriptionType.Enterprise && !!enterpriseEnabled);
}
